import { HeroContainer } from './styleComponent'

export default function MedicalBoardHeroSection({ title, description, descriptionTwo }) {
  return (
    <HeroContainer withMask={false} style={{ color: 'black' }}>
      <h1 style={{ marginBottom: '30px' }}>{title && title}</h1>
      <p className="text-center" style={{ maxWidth: '55%' }}>
        {description && description}
      </p>
      <p className="text-center" style={{ maxWidth: '55%' }}>
        {descriptionTwo && descriptionTwo}
      </p>
    </HeroContainer>
  )
}
